import api from './api';

export const automationService = {
  getAutomations: async (projectId) => {
    const response = await api.get('/automations', { params: { project: projectId } });
    return response.data;
  },

  getAutomation: async (id) => {
    const response = await api.get(`/automations/${id}`);
    return response.data;
  },

  createAutomation: async (data) => {
    const response = await api.post('/automations', data);
    return response.data;
  },

  updateAutomation: async (id, data) => {
    const response = await api.put(`/automations/${id}`, data);
    return response.data;
  },

  deleteAutomation: async (id) => {
    const response = await api.delete(`/automations/${id}`);
    return response.data;
  }
};
